module.exports = __webpack_public_path__ + "static/media/python.adafad49.png";